class FindMainProductHelper{
    static findProduct(){
        let product_data = document.querySelector('#product-data');
        if(!product_data){
            return null;
        }
        let productJsonString = product_data.getAttribute('data-product');
        if(!productJsonString){
            return null;
        }
        try{
            return JSON.parse(product_data.getAttribute('data-product'));
        }
        catch(error){
            console.log(error);
            return null;
        }
    }
}
let ProductFormValidation = new function(){
    let validationFunctions = [];
    let preAddBasketFunctions = [];
    executePreAddBasket=async ()=>{
        preAddBasketFunctions.forEach(async element => {
            await element();
        });        
    }

    executeValidations= async ()=>{
        let success = true;
        for(const element of validationFunctions ){
            success = success && await element();
            if(!success){
                return false;
            } 
        }
        return success;      
    }
    this.init = ()=>{

        function waitForElm(selector) {
            return new Promise(resolve => {
              if (document.querySelector(selector)) {
                return resolve(document.querySelector(selector));
              }
              
              const observer = new MutationObserver(mutations => {
                if (document.querySelector(selector)) {
                  resolve(document.querySelector(selector));
                  observer.disconnect();
                }
              });
              
              
              observer.observe(document.body, {
                childList: true,
                subtree: true
              });
            });
          }

          waitForElm('form[data-type=add-to-cart-form] button[type=submit]').then(elem=>{
              elem.addEventListener('click', async (e)=>{
                  e.preventDefault();
                  e.stopPropagation();
                  var executeResult = await executeValidations();
                  if(!executeResult){
                      return;
                  }else{
                    executePreAddBasket().then(()=>{
                        setTimeout(()=>e.target.closest('form').dispatchEvent(new Event('submit')), 700);
                    });
                    return false;
                }
                });
        });
    }
    this.addValidation = (fn)=>{
        validationFunctions.push(fn);
    }

    this.addPreAddBasket = (fn)=>{
        preAddBasketFunctions.push(fn);
    }
    
}
ProductFormValidation.init();